export const sleep = (duration: number) =>
  new Promise((resolve) => setTimeout(resolve, duration));

export const getParseData = (data: any) => {
  try {
    return JSON.parse(data);
  } catch (e) {
    return data;
  }
};

const capitalizeWord = (word: string) => {
  return word.charAt(0).toUpperCase() + word.slice(1);
};
export const capitalize = (str: string) => {
  if (typeof str !== "string") return "";
  return str
    .toLowerCase()
    .split(" ")
    .map((data) => capitalizeWord(data))
    .join(" ");
};
